import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

// initial state
const state = {
  details: {
    id: 0,
    name: 'Main Category'
  },
  parents: [],
  childs: [],
  availableQuota: 0,
  translations: [],
  categoriesSortList: [],
  editSortingKey: ''
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/index.js